import styled from 'styled-components'
import clearIcon from '../assets/clear-input.svg'

const ClearInputButton = styled.div<{ readonly error: boolean }>`
    visibility: ${props => props.error ? 'visible' : 'hidden'};
    opacity: ${props => props.error ? '1' : '0'};

    width: 30px;
    height: 30px;
    position: absolute;
    top: calc(50% - 15px);
    right: 8px;

    background-image: url(${clearIcon});
    background-position: center;
    background-repeat: no-repeat;

    cursor: pointer;
    transition: filter .2s, visibility 0s, opacity .2s;
    z-index: 1;
    
    &:hover {
        filter: contrast(.1);
    }
`

export default ClearInputButton